const providerMessages = {
    connection_required: 'payment_connection_required',
    verification_pending: 'verification_pending',
    verification_required: 'payment_verification_required',
    verification_rejected: 'payment_verification_rejected',
    region_unavailable: 'payment_region_unavailable',
    rate_limited: 'payment_rate_limited',
    invalid_request: 'payment_invalid_request',
    access_denied: 'payment_access_denied',
    request_conflict: 'payment_request_conflict',
    provider_unavailable: 'provider_unavailable',
};
/** Presentation only: callers retain ownership of the supplied checkout actions. */
export function fundingFeedbackPresentation(checkout) {
    if (fundingAmountValidation(checkout))
        return null;
    const error = checkout.error ??
        checkout.preview.error ??
        (checkout.state === 'amount' && checkout.preview.review?.state === 'not_executable'
            ? 'quote_not_executable'
            : null);
    const category = checkout.providerFailure?.category ?? checkout.preview.providerFailure?.category;
    if (!error)
        return null;
    const message = error === 'funding_fx_unavailable'
        ? 'funding_fx_unavailable'
        : error === 'unsupported'
            ? 'payment_device_unavailable'
            : error === 'second_factor_required'
                ? 'payment_second_factor_required'
                : error === 'quote_expired'
                    ? 'quote_expired'
                    : error === 'quote_not_executable'
                        ? 'quote_not_executable'
                        : category
                            ? providerMessages[category]
                            : error === 'verification_pending'
                                ? 'verification_pending'
                                : 'provider_unavailable';
    const connect = error === 'second_factor_required' || category === 'connection_required';
    return {
        title: error === 'quote_expired' ? 'quote_expired_title' : null,
        message,
        artwork: error === 'quote_expired' ? 'quote-expired' : null,
        action: error === 'unsupported' ? null : connect ? 'connect' : 'retry',
        actionLabel: connect
            ? 'continue_with_moonpay'
            : error === 'quote_expired'
                ? 'refresh_quote'
                : 'retry',
    };
}
/** Host translation scanners include keys selected outside their source roots. */
export const fundingFeedbackTranslationKeys = [
    ...Object.values(providerMessages),
    'funding_fx_unavailable',
    'returning_method_unavailable_title',
    'returning_method_unavailable',
    'choose_method',
    'quote_expired_title',
    'quote_expired',
    'quote_not_executable',
    'refresh_quote',
    'payment_device_unavailable',
    'payment_second_factor_required',
    'continue_with_moonpay',
    'retry',
].map((key) => `onramp.${key}`);
/** Quote input rejection is corrected by editing, not replaying the same request. */
export function fundingAmountValidation(checkout) {
    if (checkout.state !== 'amount' || checkout.error)
        return null;
    if (checkout.preview.providerFailure?.amountBoundary?.kind === 'minimum')
        return null;
    if (checkout.preview.providerFailure?.category === 'invalid_request')
        return 'payment_invalid_request';
    if (checkout.preview.review?.state === 'not_executable')
        return 'quote_not_executable';
    return null;
}
